import React, { useRef } from 'react';
import { FormControl, Autocomplete, FormHelperText, TextField, Box, Typography } from "@mui/material";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { styled } from '@mui/material/styles';
import Popper from '@mui/material/Popper';

  export default function AxionAutocomplete(props) {
    const { name, label, sx, value, error = null, onChange, inputValue, onInputChange, options, showNoneOption = true, disabled, multiple=false, defaultValue, backgroundColor, color, borderColor, fullWidth, curtainBgColor, curtainTextColor } = props;
    const shouldUseControlledValue = value !== undefined;
   
    const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
    const checkedIcon = <CheckBoxIcon fontSize="small" />;

    const StyledPopper = styled(Popper)({
      '& .MuiAutocomplete-listbox': {
        backgroundColor: curtainBgColor ??'#fff', 
        color: curtainTextColor ??'#000',
      },
      '& .MuiAutocomplete-option': {
        backgroundColor: curtainBgColor ?? '#fff', 
        color: curtainTextColor ??'#000',
      },
      '& .MuiAutocomplete-option:hover': {
        backgroundColor: '#ccc',
      },
      '& .MuiAutocomplete-option.Mui-selected': {
        backgroundColor: '#eee',
          '&:hover': {
            backgroundColor: '#ccc',
          },
      },
      '& .MuiAutocomplete-option.Mui-selected.Mui-focused': {
        backgroundColor: '#eee'
      },
      '& .MuiAutocomplete-noOptions': {
          backgroundColor: curtainBgColor ?? '#fff',  
          color: '#799c4a',
          fontStyle: 'italic',
          textAlign: 'center',
          padding: '10px',
        },
    });

    return (
      <FormControl fullWidth variant="outlined" {...(error && { error: true })}>
      <Autocomplete
          id={name} 
          name={name} 
          disabled={disabled ?? false}
          multiple={multiple}
          disableCloseOnSelect={multiple}
          options={options}
          PopperComponent={StyledPopper}
          defaultValue={defaultValue}
          {...(shouldUseControlledValue ? { value: value ?? (multiple ? [] : null) } : {})}
          inputValue={inputValue}
          onInputChange={onInputChange}
          onChange={onChange}
          getOptionLabel={(option) => option?.title ?? option?.label ?? option?.toString?.() ?? ""}
          fullWidth={fullWidth}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => <TextField {...params} label={label} />}
          slotProps={{
            paper: {
              sx: {
                backgroundColor: '#1e1e1e',
              },
            },
            listbox: {
              sx: {
                backgroundColor: '#1e1e1e',
                '& .MuiAutocomplete-option': {
                  color: '#f0f',
                },
                '& .MuiAutocomplete-option[aria-selected="true"]': {
                  backgroundColor: '#333',
                },
                '& .MuiAutocomplete-option.Mui-focused': {
                  backgroundColor: '#444',
                },
              },
            },
          }}
          sx={{ 
            '& .MuiOutlinedInput-root': {
              overflow: 'hidden',
              backgroundColor: backgroundColor ?? '#fff',
              border: '2px solid',
              borderColor: borderColor ?? '#799c4a',
              color: color ?? "#000"
            },
            '& .MuiInputLabel-root': {
              color: color ?? "#799c4a"
            },
            '& .MuiAutocomplete-popupIndicator': {
              color: "#000"
            },
            '& .MuiAutocomplete-clearIndicator': {
              color: "#000"
            },
            '& .MuiChip-root': {
              backgroundColor: '#799c4a',
              color: '#fff'
            },
            '& .MuiInputLabel-shrink': {
              transform: 'translate(14px, 0) scale(0.75)',
            },
            '& .MuiAutocomplete-clearIndicator': {
              color: color ?? "#799c4a"
            },
            '& .MuiAutocomplete-popupIndicator': {
              color: color ?? "#799c4a"
            },
            ...sx
           }}
        >
        </Autocomplete>
        {error && <FormHelperText>{error}</FormHelperText>}
      </FormControl>
    );
    
  }
  